import "./style.css";
import Results from "../../images/Problems/results.jpg";
import Money from "../../images/Problems/money.jpg";
import Digital from "../../images/Problems/digital.jpg";
import Time from "../../images/Problems/time.jpg";

export default function Problems() {
  return (
    <div className="problems">
      <div className="problems-container">
        <h1 className="problems-title">A mentoria é ideal para</h1>
        <div className="problems-cards">
          <div className="problems-card">
            <img src={Money} alt="Homem com problemas financeiros" />
            <p className="problems-card-name">Profissionais da beleza que querem<br/>agenda cheia e valorização</p>
          </div>
          <div className="problems-card">
            <img src={Results} alt="Mulher com maus resultados" />
            <p className="problems-card-name">Quem já atua na área mas sente<br/>que pode ganhar mais</p>
          </div>
          <div className="problems-card">
            <img src={Digital} alt="Mulher com maus resultados" />
            <p className="problems-card-name">Quem busca crescimento real no<br/>digital e na vida financeira</p>
          </div>
          <div className="problems-card">
            <img src={Time} alt="Homem com pouco tempo livre" />
            <p className="problems-card-name">Pessoas que querem organização,<br/>liberdade e reconhecimento</p>
          </div>
        </div>
      </div>
    </div>
  );
};